import { deviceType } from "../modules/enums";
import { AdUnit, BidParamsUserSettingsData } from "../types/prebid";
import BaseBidder from "./BaseBidder";

export default class smartx extends BaseBidder {

	constructor(slot: Slot, device: deviceType, bidderConfig: {siteId: string, sitekey: string, siteChannels: string|string[]}) {
		super(slot, device, bidderConfig);
	}

	protected getAdditionalBidParamsUserSettingsData(): BidParamsUserSettingsData[] {
		let channelValue = this.bidderConfig.siteChannels ?? '';
		if(Array.isArray(channelValue)) {
			channelValue = channelValue.join(',');
		}

		if(!channelValue) return [];

		return [
			{
				id: 'comchannel',
				name: 'comchannel',
				segment: [
					{
						id: 'comchannel',
						name: 'comchannel',
						value: channelValue
					}
				]
			}
		];
	}

	protected adUnitConfig: AdUnit = {
		code: this.slot.path,
		
		ssp: "Smartx",

		sizes: [[640, 360]],

		mediaTypes: { ...this.mediaTypeOutstreamSettings },

		bids: [{ 
			bidder: "smartx",
			params: {
				user: { ...this.bidParamsUserSettings },
				tagId: "Nu68JuOWAvrbzoyrOR9a7A",
				publisherId: "12235",

				siteId: this.bidderConfig.siteId.toString(),
				sitekey: this.bidderConfig.sitekey,
			
				cat: "",
				bidfloor: 2,
				bidfloorcur: "EUR",
				at: 2,
				cur: ["EUR"],
				outstream_options: {
					slot: this.slot.id
				},
			}
		}]
	}
}
